"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindingAttributes = void 0;
/**
 * The JSON:API attributes of the finding.
 */
class FindingAttributes {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return FindingAttributes.attributeTypeMap;
    }
}
exports.FindingAttributes = FindingAttributes;
/**
 * @ignore
 */
FindingAttributes.attributeTypeMap = {
    evaluation: {
        baseName: "evaluation",
        type: "FindingEvaluation",
    },
    evaluationChangedAt: {
        baseName: "evaluation_changed_at",
        type: "number",
        format: "int64",
    },
    mute: {
        baseName: "mute",
        type: "FindingMute",
    },
    resource: {
        baseName: "resource",
        type: "string",
    },
    resourceDiscoveryDate: {
        baseName: "resource_discovery_date",
        type: "number",
        format: "int64",
    },
    resourceType: {
        baseName: "resource_type",
        type: "string",
    },
    rule: {
        baseName: "rule",
        type: "FindingRule",
    },
    status: {
        baseName: "status",
        type: "FindingStatus",
    },
    tags: {
        baseName: "tags",
        type: "Array<string>",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=FindingAttributes.js.map